import { render, staticRenderFns } from "./PersonalInfoDetails.vue?vue&type=template&id=525e7e62"
import script from "./PersonalInfoDetails.vue?vue&type=script&lang=ts"
export * from "./PersonalInfoDetails.vue?vue&type=script&lang=ts"
import style0 from "./PersonalInfoDetails.vue?vue&type=style&index=0&id=525e7e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports